var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyllabusActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59172 9.04509L11.2604 5.15915C11.7337 4.94695 12.2663 4.94695 12.7396 5.15915L21.4083 9.04509C21.8028 9.22193 22 9.61096 22 10V16C22 16.4142 21.6642 16.75 21.25 16.75C20.8358 16.75 20.5 16.4142 20.5 16V11.3621L12.7396 14.8408C12.2663 15.0531 11.7337 15.0531 11.2604 14.8408L2.59172 10.9549C1.80276 10.6012 1.80276 9.39876 2.59172 9.04509ZM6 16V14.1266L10.6468 16.2096C11.5105 16.5968 12.4895 16.5968 13.3532 16.2096L18 14.1266V16C18 17.6569 16.6569 19 15 19H9C7.34315 19 6 17.6569 6 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabusActive);
export default __webpack_public_path__ + "static/media/syllabus-active.8fc9e3c055f01fe82389739a5b8c0ded.svg";
export { ForwardRef as ReactComponent };